import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import platform from './modules/platform'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    platform
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js